var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarmAlertBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0e6ae0;}.cls-2{fill:#0593ff;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bell"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,8a3,3,0,1,1,3-3A3,3,0,0,1,16,8Zm0-4a1,1,0,1,0,1,1A1,1,0,0,0,16,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19,24H13a1,1,0,0,0-1,1v1a4,4,0,0,0,8,0V25A1,1,0,0,0,19,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.45,24.11A6.21,6.21,0,0,1,25,18.53V15A9,9,0,0,0,7,15v3.53a6.21,6.21,0,0,1-3.45,5.58A1,1,0,0,0,4,26H28a1,1,0,0,0,.45-1.89Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmAlertBell);
export default __webpack_public_path__ + "static/media/alarm_alert_bell.92836703e43181f225bef07a811e6955.svg";
export { ForwardRef as ReactComponent };